import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, MapPin } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { useLang } from "../i18n/LanguageContext";

const photoSrc = (url) => (url?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

const Avatar = ({ m }) => m.photo_url
  ? <img src={photoSrc(m.photo_url)} alt="" className="h-16 w-16 rounded-full object-cover ring-2 ring-gold/60" />
  : <div className="flex h-16 w-16 items-center justify-center rounded-full bg-crimson/90 font-serif-display text-2xl font-bold text-parchment ring-2 ring-gold/60">{m.first_name[0]}</div>;

export function NewMemberStrip() {
  const { data } = useApi("/public/new-members?limit=8");
  const { t } = useLang();
  const items = data?.items || [];
  if (items.length === 0) return null;
  return (
    <section id="new-members" className="scroll-mt-24 border-y border-gold/25 bg-gold-light/60 py-10" data-testid="new-member-strip">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="eyebrow flex items-center gap-1 text-crimson"><Sparkles size={14} className="text-gold" /> {t("Akwaaba")}</p>
            <h2 className="font-serif-display text-base font-bold md:text-lg">{t("Please welcome our newest members")}</h2>
          </div>
          <Link to="/membership" className="text-sm font-semibold text-crimson underline-offset-4 hover:underline" data-testid="new-member-join-link">{t("Become a member")} →</Link>
        </div>
        <ul className="flex gap-4 overflow-x-auto pb-2 [scrollbar-width:thin]">
          {items.map((m, i) => (
            <li key={m.id} className="flex w-36 shrink-0 flex-col items-center rounded-2xl bg-white/70 p-4 text-center shadow-sm backdrop-blur transition-transform hover:-translate-y-1" style={{ animationDelay: `${i * 60}ms` }} data-testid={`new-member-${m.id}`}>
              <Avatar m={m} />
              <p className="mt-3 font-semibold">{m.first_name}</p>
              {m.hometown && <p className="flex items-center gap-1 text-xs text-muted-foreground"><MapPin size={11} /> {m.hometown}</p>}
              <p className="mt-1 font-mono-accent text-[10px] uppercase tracking-wider text-palm">{m.featured ? t("Akwaaba") : (m.registered ? t("Registered") : t("Joined"))} {m.joined}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
